// Environment
export const NODE_ENV = process.env.NODE_ENV ?? 'development';

// Network
export const PORT = process.env.PORT ?? 3000;

export const API_ADDRESS = process.env.REACT_APP_API_ADDRESS ?? `http://localhost:8888`;
export const APP_ADDRESS = process.env.REACT_APP_APP_ADDRESS ?? `http://localhost:${PORT}`;
export const CUSTOM_SIGN_IN_ADDRESS = process.env.REACT_APP_CUSTOM_SIGN_IN_ADDRESS ?? '';

export const FITROOM_WIDGET_SERVICE_ADDRESS = `${API_ADDRESS}/fitroom-widget`;
export const VTO_AVATARS_ADDRESS = `${API_ADDRESS}/vto-avatars`;
export const VTO_CLOSETS_ADDRESS = `${API_ADDRESS}/vto-closets`;
export const VTO_GARMENTS_ADDRESS = `${API_ADDRESS}/vto-garments`;

// Firebase
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY ?? '';
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID ?? '';
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? '';
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? '';
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID ?? '';
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? '';

// Build
const WA_AVATARS_FS_FILE = process.env.REACT_APP_WA_AVATARS_FS_FILE ?? 'wa-avatars/index.data';

export const WA_AVATARS_FS_URL = `${APP_ADDRESS}/${WA_AVATARS_FS_FILE}`;

// Development credentials
export const APP_KEY = 'teBx2QRYJohDMgWvVAtiqdsxGWzNFTpIZXS8pb8WlE6jb0fxthgdKCfB9OSJz91e';

// Whether to use single credentials with custom token or individual user sign-in
// TODO: move this to a host value fetched by the widget
export const USE_USER_SIGN_IN = process.env.REACT_APP_USE_USER_SIGN_IN === 'true' ?? false;
